module.exports = __webpack_public_path__ + "src/assets/ru.6a201bfc.png";